import React, { useState, useEffect } from 'react';

const JsonNavigator = ({ data }) => {
  const [collapsed, setCollapsed] = useState({});

  // Initialiser toutes les clés comme collapsed par défaut lors du premier rendu
  useEffect(() => {
    const initialCollapsedState = {};
    const buildCollapsedState = (obj, path = '') => {
      if (typeof obj === 'object' && obj !== null) {
        Object.keys(obj).forEach(key => {
          const newPath = `${path}${path ? '.' : ''}${key}`;
          initialCollapsedState[newPath] = true;
          buildCollapsedState(obj[key], newPath);
        });
      }
    };
    buildCollapsedState(data);
    setCollapsed(initialCollapsedState);
  }, [data]);

  const toggleCollapse = path => {
    setCollapsed(prevState => ({
      ...prevState,
      [path]: !prevState[path],
    }));
  };

  // Ajustement du composant pour utiliser les styles ci-dessus
const renderPrimitive = (key, value) => {
    return (
      <div style={styles.primitivePair}>
        <div style={styles.key}>{key}</div>
        <div style={styles.value}>{value}</div>
      </div>
    );
  };

  const renderEntries = (obj, parentPath = '') => {
    return Object.entries(obj).map(([key, value], index) => {
      const path = `${parentPath}${parentPath ? '.' : ''}${key}`;
      if (typeof value === 'object' && value !== null) {
        return (
          <div key={path} style={styles.pair}>
            <div onClick={() => toggleCollapse(path)} style={styles.collapseButton}>
              {collapsed[path] ? '▶' : '▼'} <span style={styles.key}>{key}</span>
            </div>
            {/*!collapsed[path] && <div style={styles.nestedObject}>{renderEntries(value, path)}</div>*/}
            {!collapsed[path] && <JsonNavigator data={value}/>}
          </div>
        );
      } else {
        return renderPrimitive(key, value);
      }
    });
  };

  return (
    <div style={{paddingTop: '5px' }}>
      {Array.isArray(data) ? data.map((item, index) => (
        <div key={index} style={styles.arrayItem}>
          {renderEntries(item, String(index))}
        </div>
      )) : renderEntries(data)}
    </div>
  );
};

const styles = {
    objectContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)', // Trois colonnes, vous pouvez ajuster le nombre comme nécessaire
        gridAutoRows: 'auto auto', // Deux rangées pour chaque cellule de la grille: une pour la clé, une pour la valeur
        gap: '10px', // Espace entre les cellules de la grille
        alignItems: 'start',
    },
    key: {
        fontWeight: 'bold',
        gridArea: '1 / span 3', // La clé s'étend sur les trois colonnes
    },
    value: {
        gridArea: '2 / span 3', // La valeur s'étend sur les trois colonnes
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100%', // Assurez-vous que cela ne dépasse pas la largeur de la cellule
      },
    primitivePair: {
        marginBottom: '10px',
        display: 'grid',
        gridTemplateColumns: '1fr', // Une seule colonne pour la clé et la valeur
        maxWidth: '200px', // Largeur fixe pour la colonne
    },
    collapseButton: {
        cursor: 'pointer',
        fontWeight: 'bold',
        background: '#f3f3f3', // Nuance de gris pour le bouton
        borderRadius: '4px',
        padding: '6px 10px', // Un peu de padding pour le bouton
        boxShadow: 'inset 0 2px 5px rgba(0,0,0,0.1)', // Un effet d'enfoncement pour le bouton
        margin: '5px 0', // Espace autour du bouton
        alignItems: 'center',
        display: 'flex',
    },
    pair: {
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr)', // Une colonne pour la clé, une pour la valeur
        gap: '10px', // Espace entre la clé et la valeur
        alignItems: 'start', // Aligner les éléments de grille au début
    },
    nestedObject: {
        paddingLeft: '20px', // Augmentation de l'indentation pour les objets imbriqués
        borderLeft: '2px solid #e8e8e8', // Bordure à gauche pour indiquer la hiérarchie
        marginLeft: '10px', // Espace à gauche de la bordure
        paddingBottom: '10px', // Espace en dessous de l'objet imbriqué
        background: '#fafafa', // Un fond légèrement différent pour les objets imbriqués
    },
    arrayItem: {
        marginBottom: '10px',
        background: '#f9f9f9', // Nuance de gris pour les éléments de tableau
        boxShadow: '0 2px 5px rgba(0,0,0,0.05)', // O
  }
};

export default JsonNavigator;
